import React from "react";
import { ShieldX } from "lucide-react";
import { Link } from "react-router-dom";
import "./_styles.scss";

const PageAcessoNegado = () => {
  return (
    <div className="acesso-negado-container">
      <div className="acesso-negado-box">
        <ShieldX className="acesso-negado-icon" size={64} />
        <h1>Acesso Negado</h1>
        <p>
          Você não tem as permissões necessárias para visualizar esta página.
        </p>
        <Link to="/dashboard" className="btn-voltar">
          Voltar para o Dashboard
        </Link>
      </div>
    </div>
  );
};

export default PageAcessoNegado;
